import Badge from "@cloudscape-design/components/badge"
import Link from "@cloudscape-design/components/link"
import { useNavigate } from "react-router-dom"

import type { DiffStatus } from "../../utils/inlineDiff"

interface DiffBadgeProps {
  status: DiffStatus
  version: string
  dtaId: string
  section: string
  item: string
}

export function DiffBadge({ status, version, dtaId, section, item }: DiffBadgeProps) {
  const navigate = useNavigate()
  const fromVer = `${Number(version.split(".")[0]) - 1}.0`
  const href = `/dtas/${dtaId}/compare?from=${fromVer}&to=${version}&section=${section}&item=${encodeURIComponent(item)}`
  const label = status === "new" ? `new in v${version}` : `modified in v${version}`

  return (
    <Link
      href={href}
      onFollow={(event) => {
        // Keep SPA navigation instead of a full page reload.
        if (!event.detail.external) {
          event.preventDefault()
          navigate(href)
        }
      }}
    >
      <Badge color={status === "new" ? "green" : "severity-medium"}>{label}</Badge>
    </Link>
  )
}
